import { normalizeAppRole, normalizeAppRoles } from './role-utils';

export type WorkspaceShell = 'provider' | 'nurse' | 'frontdesk' | 'admin' | 'partner' | 'super_admin' | 'other';

export const PARTNER_ROLES = ['billing_partner', 'credentialing_partner', 'supply_partner'] as const;
export function hasPartnerRole(values: readonly unknown[]): boolean {
  return normalizeAppRoles([...values]).some(role => (PARTNER_ROLES as readonly string[]).includes(role));
}

const ADMIN_ROLES = new Set(['admin', 'org_admin', 'clinical_admin']);
const PROVIDER_ROLES = new Set(['provider', 'np']);
const NURSE_ROLES = new Set(['nurse', 'lpn', 'wound_nurse', 'don']);
const FRONTDESK_ROLES = new Set(['employer', 'employee', 'frontdesk', 'reception', 'receptionist', 'scheduler', 'hr']);

export function workspaceShellForRoles(values: unknown[], primary?: unknown): WorkspaceShell {
  const roles = normalizeAppRoles([
    ...values,
    ...(normalizeAppRole(primary) ? [primary] : []),
  ]);

  if (hasPartnerRole(roles)) return 'partner';
  if (roles.includes('super_admin')) return 'super_admin';
  if (roles.some((role) => ADMIN_ROLES.has(role))) return 'admin';
  if (roles.some((role) => PROVIDER_ROLES.has(role))) return 'provider';
  if (roles.some((role) => NURSE_ROLES.has(role))) return 'nurse';
  if (roles.some((role) => FRONTDESK_ROLES.has(role))) return 'frontdesk';
  return 'other';
}

export function workspaceHomeForShell(shell: WorkspaceShell): string {
  switch (shell) {
    case 'partner': return '/partner/dashboard';
    case 'super_admin': return '/super-admin/dashboard';
    case 'admin': return '/admin/dashboard';
    case 'provider': return '/provider/dashboard';
    case 'nurse': return '/nurse/dashboard';
    case 'frontdesk': return '/patients/dashboard';
    default: return '/forbidden';
  }
}
